import React, { useState } from "react";
import "./ManageSorteoView.css";

const ManageSorteoView = ({ sorteos, refresh }) => {
  // --- ESTADOS ---
  const [loading, setLoading] = useState(false);
  const [mensaje, setMensaje] = useState({ texto: "", tipo: "" });

  // Formulario para nuevo/editar
  const [formData, setFormData] = useState({
    id: null,
    nombreSorteo: "",
    fechaSorteo: "",
    activo: true,
    actual: false,
  });

  const API_URL = process.env.REACT_APP_API_URL || "";

  // --- CARGA DE DATOS ---
  /* const fetchSorteos = async () =>
  {
    setLoading( true );
    try
    {
      const response = await fetch( `${ API_URL }/sorteos_disponibles/` );
      if ( !response.ok ) throw new Error( "Error al obtener sorteos" );
      const data = await response.json();
      setSorteos( data );
    } catch ( err )
    {
      console.error( "Error cargando sorteos:", err );
      setMensaje( { texto: "❌ No se pudieron cargar los sorteos.", tipo: "error" } );
    } finally
    {
      setLoading( false );
    }
  }; */

  /* useEffect( () =>
  {
    fetchSorteos();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [] ); */

  // --- MANEJADORES ---
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const limpiarFormulario = () => {
    setFormData({
      id: null,
      nombreSorteo: "",
      fechaSorteo: "",
      activo: true,
      actual: false,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMensaje({ texto: "", tipo: "" });

    try {
      const isUpdating = !!formData.id;
      const url = isUpdating
        ? `${API_URL}/actualizar_sorteo/`
        : `${API_URL}/crear_sorteo/`;

      const method = isUpdating ? "PUT" : "POST";

      // Para crear, el API no espera el campo 'id'
      const { id, ...dataToSend } = formData;
      const body = isUpdating ? formData : dataToSend;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("access_token")}`,
        },
        body: JSON.stringify(body),
      });

      const result = await response.json();

      if (!response.ok) {
        throw new Error(result.detail || "Error en la operación");
      }

      setMensaje({
        texto: isUpdating
          ? "✅ Sorteo actualizado correctamente"
          : "✅ Sorteo creado exitosamente",
        tipo: "exito",
      });

      limpiarFormulario();
      /* fetchSorteos(); */
      refresh();
    } catch (err) {
      setMensaje({ texto: `❌ ${err.message}`, tipo: "error" });
    } finally {
      setLoading(false);
    }
  };

  const seleccionarSorteoActual = async (id) => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/seleccionar_sorteo/${id}`, {
        method: "PUT",
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(errorData.detail || "Error al seleccionar");
      }

      setMensaje({ texto: "🚀 Sorteo establecido como ACTUAL", tipo: "exito" });
      /* fetchSorteos(); */
      refresh();
    } catch (err) {
      setMensaje({ texto: `❌ ${err.message}`, tipo: "error" });
    } finally {
      setLoading(false);
    }
  };

  const eliminarSorteo = async (id) => {
    if (!window.confirm("¿Estás seguro de eliminar este sorteo?")) return;
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/eliminar_sorteo_por/${id}`, {
        method: "DELETE",
      });

      if (!response.ok) throw new Error("No se pudo eliminar el sorteo");

      setMensaje({ texto: "🗑️ Sorteo eliminado", tipo: "exito" });
      /* fetchSorteos(); */
      refresh();
    } catch (err) {
      setMensaje({ texto: `❌ ${err.message}`, tipo: "error" });
    } finally {
      setLoading(false);
    }
  };

  const editarEnForm = (sorteo) => {
    setFormData({
      id: sorteo._id,
      nombreSorteo: sorteo.nombreSorteo,
      fechaSorteo: sorteo.fechaSorteo,
      activo: sorteo.activo,
      actual: sorteo.actual,
    });
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const toggleEstatusActivo = async (id, estatusActual) => {
    setLoading(true);
    try {
      const nuevoEstatus = !estatusActual;
      const response = await fetch(
        `${API_URL}/actualizar_sorteo_estatus/${id}`,
        {
          method: "PUT",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ activo: nuevoEstatus }),
        }
      );

      if (!response.ok) throw new Error("No se pudo cambiar el estatus");

      setMensaje({
        texto: nuevoEstatus ? "🟢 Sorteo activado" : "⚪ Sorteo desactivado",
        tipo: "exito",
      });
      /* fetchSorteos(); */
      refresh();
    } catch (err) {
      setMensaje({ texto: `❌ ${err.message}`, tipo: "error" });
    } finally {
      setLoading(false);
    }
  };

  const haySorteoEnPausa = sorteos.some(
    (s) => s.actual === true && s.activo === false
  );

  return (
    <div
      className="patrones-view"
      style={{
        backgroundColor: "#222222",
        minHeight: "100vh",
        display: "flex",
        flexWrap: "wrap",
        gap: "20px",
        justifyContent: "flex-start",
        padding: "40px 20px",
        fontFamily: "system-ui, sans-serif",
      }}
    >
      <div className="panelBordeRojo inicial">
        <h2 style={{ color: "#fff", marginBottom: "20px", fontSize: "1.5rem" }}>
          {formData.id ? "📝 Editar Sorteo" : "➕ Nuevo Sorteo"}
        </h2>

        <form onSubmit={handleSubmit} className="sorteo-form">
          <div className="sorteo-select">
            <h3>Nombre del Sorteo</h3>
            <input
              type="text"
              name="nombreSorteo"
              value={formData.nombreSorteo}
              onChange={handleChange}
              placeholder="Ej: Sorteo Dominical"
              required
            />
          </div>

          <div className="sorteo-select">
            <h3>Fecha</h3>
            <input
              type="date"
              name="fechaSorteo"
              value={formData.fechaSorteo}
              onChange={handleChange}
              required
            />
          </div>

          <div className="checkbox-group">
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                name="activo"
                checked={formData.activo}
                onChange={handleChange}
              />{" "}
              Activo
            </label>
            <label
              style={{
                display: "flex",
                alignItems: "center",
                gap: "5px",
                cursor: "pointer",
              }}
            >
              <input
                type="checkbox"
                name="actual"
                checked={formData.actual}
                onChange={handleChange}
              />{" "}
              Es el Actual
            </label>
          </div>

          <div style={{ display: "flex", gap: "10px" }}>
            <button type="submit" className="boton-sorteo" disabled={loading}>
              {loading
                ? "Procesando..."
                : formData.id
                ? "Guardar Cambios"
                : "Crear Sorteo"}
            </button>
            {formData.id && (
              <button
                type="button"
                className="boton-sorteo"
                style={{ background: "#444" }}
                onClick={limpiarFormulario}
              >
                Cancelar
              </button>
            )}
          </div>
        </form>

        {mensaje.texto && (
          <div className={`mensaje-confirmacion ${mensaje.tipo}`}>
            {mensaje.texto}
          </div>
        )}
      </div>

      <div className="panelBordeRojo">
        <h2 style={{ color: "#fff", marginBottom: "20px", fontSize: "1.5rem" }}>
          📋 Lista de Sorteos
        </h2>

        {sorteos.length === 0 && !loading && (
          <p style={{ color: "#888", textAlign: "center" }}>
            No hay sorteos registrados.
          </p>
        )}

        {sorteos.map((s) => (
          <div key={s._id} className="sorteo-item-card">
            <div style={{ display: "flex", flexDirection: "column" }}>
              <span
                style={{
                  fontWeight: "bold",
                  fontSize: "1.1rem",
                  color: "#fff",
                }}
              >
                {s.nombreSorteo}
                {s.actual && <span className="badge-actual">ACTUAL</span>}
              </span>
              <span style={{ fontSize: "0.9rem", color: "#ccc" }}>
                {s.fechaSorteo} — {s.activo ? "🟢 Activo" : "🔴 Inactivo"}
              </span>
            </div>
            <div className="acciones">
              <button
                onClick={() => seleccionarSorteoActual(s._id)}
                title="Marcar como Sorteo Actual"
                disabled={s.actual || loading}
              >
                🎯
              </button>
              <button
                onClick={() => toggleEstatusActivo(s._id, s.activo)}
                // LÓGICA: Bloquea si hay uno en pausa, EXCEPTO si este sorteo es el que está en pausa
                disabled={
                  haySorteoEnPausa && !(s.actual === true && s.activo === false)
                }
                style={{
                  backgroundColor: s.activo ? "#10b981" : "#6b7280",
                  // Estilo visual para los botones bloqueados
                  opacity:
                    haySorteoEnPausa &&
                    !(s.actual === true && s.activo === false)
                      ? 0.4
                      : 1,
                  cursor:
                    haySorteoEnPausa &&
                    !(s.actual === true && s.activo === false)
                      ? "not-allowed"
                      : "pointer",
                }}
              >
                {s.activo ? "💡" : "🔌"}
              </button>
              <button
                onClick={() => editarEnForm(s)}
                title="Editar Sorteo"
                disabled={loading}
              >
                ✏️
              </button>
              <button
                onClick={() => eliminarSorteo(s._id)}
                title="Eliminar Sorteo"
                disabled={loading}
              >
                🗑️
              </button>
            </div>
          </div>
        ))}

        {loading && (
          <div
            style={{
              color: "#667eea",
              textAlign: "center",
              padding: "10px",
              fontWeight: "bold",
            }}
          >
            Actualizando...
          </div>
        )}
      </div>
    </div>
  );
};

export default ManageSorteoView;
